<script lang="ts">
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';

    const src = '/promo-msp/shop-and-win';

    let empty = $state(false);
</script>

<div class="reptile-lottery-communication" class:reptile-lottery-communication--empty={empty}>
    <DynamicEsi {src} name="LotteryCommunication" onEmptyChange={(value) => (empty = value)} />
</div>

<style lang="scss">
    .reptile-lottery-communication {
        grid-column: 1 / -1;
        width: 100%;

        &--empty {
            display: none;
        }
    }
</style>
